// extracted by css-extract-rspack-plugin
export default {"button":"VRqCf","icon":"_95RQ"};